// Create a utility function to generate channel URLs
const generateChannelUrl = (channel, isPublic = false, forceId = false) => {
    if (!channel) return null;

    const { type, channelId, id, entity, uniqueName} = channel;

    // Validate channel type
    if (type !== 'team' && type !== 'group' && type !== 'organization') {
        return null;
    }

    const useId = uniqueName && !forceId ? uniqueName :
                    entity?.uniqueName && !forceId ? entity.uniqueName :
                      channelId || id;
    const publicPrefix = isPublic ? '/public' : '';

    return `${publicPrefix}/${type}/${useId}`;
};

export default generateChannelUrl;